import { createTheme, darkScrollbar } from '@mui/material';
import { backgroundSecondaryDark } from './brandColors';
import { productionColors, sharedThemeTokens } from './shared';

export const Holiday = createTheme(
  {
    palette: {
      mode: 'dark',
      primary: {
        main: 'hsl(120, 100%, 30%)',
      },
      secondary: {
        main: 'hsl(0, 70%, 50%)',
      },
      background: {
        default: 'hsl(0, 0%, 18%)',
        paper: 'hsl(0, 0%, 18%)',
        secondary: backgroundSecondaryDark,
      },
      text: {
        primary: 'hsl(0, 0%, 100%)',
        secondary: 'hsl(51, 100%, 50%)',
      },
      warning: {
        main: 'hsl(51, 100%, 50%)',
      },
      error: {
        main: 'hsl(0, 70%, 50%)',
      },
    },
    typography: {
      fontFamily: '"Mountains of Christmas", serif',
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: darkScrollbar(),
        },
      },
    },
    borderColor: 'hsla(51, 100%, 50%, 0.4)', // rgba(255, 215, 0, 0.4) → Gold
    productionColors,
  },
  sharedThemeTokens
);
